import { Model, AccessorsMutatorsDecorator } from "../../helpers";

/**
 * @class Language
 * @property {string} code
 * @property {string} name
 * @property {boolean} rtl
 * @property {boolean} default
 */
export class Language extends Model {

    static isDefault(language) {

        language = language instanceof this ? language.code : `${language}`.toLowerCase();

        return !!LANGUAGES.find((lang) => lang.is(language) && lang.default);
    }

    setCode(value) {

        return `${value}`.toLowerCase();
    }

    /**
     * @param {string} code
     * @returns {boolean}
     */
    is(code) {

        return `${code}`.toLowerCase() === this.code;
    }
    
    direction() {

        return this.rtl? 'rtl': 'ltr';
    }
}

AccessorsMutatorsDecorator('code', 'name', 'rtl', 'default')(Language);

export const LANGUAGES = [
    new Language({
                     code: 'ar',
                     name: 'ARABIC',
                     rtl: true,
                     default: false
                 }),
    new Language({
                     code: 'en',
                     name: 'ENGLISH',
                     rtl: false,
                     default: true
                 })
];


// WEBPACK FOOTER //
// ./src/pms-api/models/language.model.js